import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'bp-we-are-hiring-badge',
	template: 'We’re hiring!',
	styleUrls: [ './we-are-hiring-badge.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeAreHiringBadgeComponent { }
